<template>
    <div class="energy-data-query-manage-box">
        <div class="recharge-detail-query-head">
            <div class="recharge-detail-query-head-left">
                <el-row>
                    <el-col>用户列表</el-col>
                </el-row>
            </div>
            <div class="recharge-detail-query-head-right">
                <el-row>
                    <el-col style="height: 2rem;padding-left: 2rem">能耗趋势图

                        <el-radio-group v-model="tabPosition" size="mini" style="float: right;" :disabled="disabled">
                            <el-radio-button label="1">能耗量</el-radio-button>
                            <el-radio-button label="0">能耗费用</el-radio-button>
                        </el-radio-group>

                        <el-date-picker
                                type="daterange"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                size="small"
                                style="width: 16vw;margin-right: 1rem;float: right;"
                                v-model="date"
                                @change="changeTime"
                                time-arrow-control
                                align="left"
                                :disabled="disabled"
                        >
                        </el-date-picker>
                        <el-radio-group v-model="dateUnit" size="mini"
                                        @change="changeDateUnit" style="float: right;margin-right: 1rem;"
                                        :disabled="disabled">
                            <el-radio-button label="day">日</el-radio-button>
                            <el-radio-button label="week">周</el-radio-button>
                            <el-radio-button label="month">月</el-radio-button>
                            <el-radio-button label="year">年</el-radio-button>
                        </el-radio-group>


                        <!--<el-button size="mini" type="primary" @click="echarts('day')">查询</el-button>-->


                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="energy-data-query-content">
            <div class="energy-data-query-left">
                <center>
                    <div class="left-item">
                        <el-form>
                            <!--<el-row style="height: 30px">-->
                            <el-row style="height: 2rem">
                                <el-col>
                                    <el-input v-model="filterText" size="small" :disabled="disabled" style="width: 85%">
                                        <template slot="prepend" style="padding: 0;width:50%;">用户名称/编号</template>
                                    </el-input>
                                    <!--<el-form-item label="用户名称/编号" :label-width="formLabelWidth">
                                        <el-input
                                                v-model="condition.customerId"
                                                class="row" size="mini">
                                        </el-input>
                                    </el-form-item>-->
                                </el-col>
                            </el-row>
                            <!--<el-row>
                                <el-col>
                                    <el-button size="mini" @click="">搜 索</el-button>
                                </el-col>
                            </el-row>-->
                            <!--<el-row style="margin-top: 5px;height: 30px">-->
                            <el-row style="margin-top: 1rem;height: 2rem">
                                <el-col>
                                    <el-radio-group v-model="meterType" size="mini" :disabled="disabled">
                                        <el-radio-button label="2">电表</el-radio-button>
                                        <el-radio-button label="1">水表</el-radio-button>

                                    </el-radio-group>
                                </el-col>
                            </el-row>

                        </el-form>

                    </div>
                    <div class="div-hr"></div>

                    <div class="tree">
                        <el-container>
                            <!--<el-main ref="elMain" style="height: calc(100vh - 220px)">-->
                            <el-main ref="elMain" style="height: calc(100vh - 20rem)">
                                <el-tree
                                        class="filter-tree"
                                        :data="tree"
                                        :props="defaultProps"
                                        :filter-node-method="filterNode"
                                        node-key="id"
                                        :default-expanded-keys="expandedKeys"
                                        v-loading="loading"
                                        @node-click="click"
                                        :expand-on-click-node="false"
                                        ref="tree"
                                        highlight-current
                                        :indent="fontSize"
                                        style="background-color: #fafafa"
                                >
                                </el-tree>
                                <el-button v-show="tree.length === 0 && !loading" @click="reLoad">刷新</el-button>

                            </el-main>
                        </el-container>


                    </div>

                    <!--<div class="log-condition-box">




                    </div>-->


                </center>
            </div>

            <div class="energy-data-query-right">
                <!--<el-radio-group v-model="time" style="margin-left: 15px;">
                    <el-row>
                        <el-radio-button label="day">日</el-radio-button>
                    </el-row>
                    <el-row>
                        <el-radio-button label="week">周</el-radio-button>
                    </el-row>
                    <el-row>
                        <el-radio-button label="month">月</el-radio-button>
                    </el-row>
                    <el-row>
                        <el-radio-button label="year">年</el-radio-button>
                    </el-row>

                </el-radio-group>-->

                <div class="content" v-loading="dataLoading">

                    <div class="content-echarts" id="myChart" style="width: 100%;height: 30vh;background-color: white;">

                        <!--<div class="myChart" id="myChart" style="width: 100%;height:100%;"></div>-->
                    </div>

                    <div class="left-item" style="font-size: 0.9375rem;
                font-weight: 600;

                    margin-top: 1rem;">
                        能耗记录
                    </div>
                    <div class="content-table">

                        <flex>
                            <el-table
                                    :data="tableData"
                                    stripe
                                    size="small"
                                    style="width:100%;"
                                    height="100%"

                            >
                                <!-- height="calc(70vh - 205px)" width="100%"-->
                                <!--<el-table-column v-for="(item,index) in tableColumn" :label="item.name"
                                                :prop="item.prop" v-if="item.show" :key="index" align="center" :render-header="labelHead"></el-table-column>-->
                                <!--:row-style="cellHeight"
                                      style="width: 100%"
                                    row-style="height:0"
                                    cell-style="padding:0"-->
                                <!-- <el-table-column
                                         type="selection">

                                 </el-table-column>-->
                                <el-table-column
                                        label="序号"
                                        width="50%">
                                    <template slot-scope="scope">
                                        <span>{{scope.$index+(currentPage - 1) * pageSize + 1}} </span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        align="center"
                                        prop="time"
                                        label="时间"
                                        :formatter="tableTimeFormat">

                                </el-table-column>
                                <el-table-column
                                        align="center"
                                        prop="customerName"
                                        label="用户名称"
                                        :formatter="tableStringFormat">
                                </el-table-column>

                                <el-table-column
                                        align="center"
                                        prop="meterId.name"
                                        :formatter="tableStringFormat"
                                        label="仪表名称"
                                >
                                </el-table-column>
                                <el-table-column
                                        align="center"
                                        prop="meterId.code"
                                        :formatter="tableStringFormat"
                                        label="仪表编号">
                                </el-table-column>
                                <el-table-column
                                        align="center"
                                        prop="meterId.meterNum"
                                        :formatter="tableStringFormat"
                                        label="表号">
                                </el-table-column>

                                <el-table-column
                                        align="center"
                                        prop="meterId.energyType"
                                        :formatter="tableStringFormat"
                                        label="能耗类型">
                                </el-table-column>
                                <el-table-column
                                        align="center"
                                        prop="timeEnergyData.energyValue"
                                        :formatter="tableStringToFixed"
                                        :label="dataLabel"
                                >
                                </el-table-column>
                                <!--:render-header="labelHead"-->

                                <el-table-column
                                        align="center"
                                        prop="timeMoneyData.energyValue"
                                        :formatter="tableStringToFixed"
                                        label="能耗费用(元)">
                                </el-table-column>

                            </el-table>

                        </flex>
                        <div class="energy-data-query-pagination">


                            <el-pagination
                                    background
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="currentPage"
                                    :page-sizes="[20, 50, 100, 500, 1000]"
                                    :page-size="pageSize"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="pageTotal" style="width:100%;height: 100%;"
                                    align="center"
                                    :disabled="disabled">
                            </el-pagination>


                            <el-button @click="excel" size="small" :disabled="disabled">数据导出</el-button>


                        </div>
                    </div>
                    <!-- <div style="width: 100%;height:30px;padding-bottom: 5px">-->

                </div>
            </div>
        </div>

    </div>

</template>

<script>
  /* eslint-disable indent */

  import {energyUnitEnergyData} from '@/api/EnergyUnit'
  import {getStartAndEnd, formatToHour, formatToDay, formatToMonth, formatDate, format} from '@/utils/time'
  import echarts from 'echarts'
  import {
    formartData,
    formartDataById,
    addTitle,
    formatTitle,
    formatDataByType,
    concatAllData,
    selectMeters
  } from '@/utils/energyData'
  /* import { meterMoneyData } from '@/api/Meter'*/
  import {tree, expandedCustomerWithMeter, filterNode} from '@/utils/energyUtilTree'
  import {getEnergyItem} from '@/api/EnergyItem'
  import {exportExcel} from '@/utils/excelUtil'
  import {option} from '@/utils/echartsUtile'
  import {getCustomerEnergy} from '@/api/customerEnergy'
  import {mapGetters} from 'vuex'
  import Flex from "../../../components/Flex"

  export default {
    name: 'meterManage',
    components: {
      'flex': Flex
    },
    computed: {
      ...mapGetters([
        'screenWidth',
        'fontSize'
      ])
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val)
      },
      screenWidth() {
        if (!this.timer) {
          this.timer = true
          setTimeout(() => {
            this.myChart.resize()
            this.timer = false
          }, 10)
        }
      },
      meterType() { // 监听能源类型变化
        this.cleanData()
        if (this.meterType === '2') {
          this.dataLabel = '能耗量(kWh)'
        }
        else this.dataLabel = '能耗量(m³)'
        this.selectEnergyUnit().then(response => {
          /*默认展开和获取第一位业主用户的所有表信息*/
          this.expandedCustomerWithMeter(response).then(() => {
            this.energyUnitEnergyData()
          })
        })
      },
      tabPosition() {
        if (this.tabPosition === '0') {
          this.drawECharts(this.energyMoneySet)
        }

        else {
          this.drawECharts(this.energyDataSet)
        }
      }
    },
    mounted() {
      this.tree = []
      /*查询客户分项ids*/
      this.getCustomerEnergy(this.$store.getters.customerId).then(() => {
        /*初始化ECharts*/
        this.myChart = echarts.init(document.getElementById('myChart'))
        this.myChart.on('legendselectchanged', (obj) => {
          this.selected = obj.selected
        })
        /*构建能耗树*/
        this.selectEnergyUnit().then(response => {

          /*默认展开和获取第一位业主用户的所有表信息*/
          this.expandedCustomerWithMeter(response).then(() => {

            this.echarts('initialize')

          })
        })
        /*获取能耗单元树,以及第一个用户的id以及其所拥有的所有仪表的id 并查询echarts数据和画图*/
        /*window.onresize = () => {

        }*/
      })


      // this.elMainStyle.height = parseInt(this.$refs.elMain.$el.clientHeight * 2.5) + 'px'
      /* this.elContent.height = parseInt(this.$refs.content.$el.clientHeight * 1) + 'px'*/

      /* this.myChart.resize();*/
    },
    methods: {
      cleanData() {
        /*console.log('清理数据')*/
        this.finallyData = []
        this.tableData = []
        this.excelData = []
        this.meters = []
        this.meter = []
        this.energyData = []
        this.energyMoney = []
        this.energyDataSet = []
        this.energyMoneySet = []
        this.currentPage = 1
        this.condition.energyUnitIds = ''
      },
      reLoad() {
        this.selectEnergyUnit().then(response => {
          /*默认展开和获取第一位业主用户的所有表信息*/
          this.expandedCustomerWithMeter(response).then(() => {
            this.echarts('initialize')
          })
        })
      }, labelHead(h, {column, index}) {
        const l = column.label.length
        const f = 16 // 每个字大小，其实是每个字的比例值，大概会比字体大小差不多大一点，
        column.minWidth = f * l // 字大小乘个数即长度 ,注意不要加px像素，这里minWidth只是一个比例值，不是真正的长度
        // 然后将列标题放在一个div块中，注意块的宽度一定要100%，否则表格显示不完全
        return h('div', {class: 'table-head', style: {width: '100%'}}, [column.label])
      },
      getCustomerEnergy(customerId) {
        return new Promise((resolve, reject) => {
          getCustomerEnergy(customerId).then(response => {
            debugger
            if (response.code === 200) {
              const customerEnergy = response.infoJson;
              customerEnergy.forEach(item => {
                this.condition.energyItemIds += item.energyId + ','
              })
              resolve(null)
            }
            else {
              reject(response.message)
            }
          }).catch(error => {
            reject(error)
          })
        })
      },
      searchByPage(data) {
        if (data === null || data === undefined) return
        /* 数据总个数dataTotal, pageTotal总页数, 每页个数pagesize, 当前页数currentPage*/
        const dataTotal = data.length
        this.pageTotal = dataTotal
        /* dataTotal / pageSize + ((dataTotal % pageSize) > 0 ? 1 : 0);*/
        const start = ((this.currentPage - 1) * this.pageSize)
        const end = this.currentPage * this.pageSize
        return data.slice(start, end)
      },
      echarts(val) { /* 根据查询数据绘制echarts图表*/
        if (val === 'initialize') {
          this.changeDateUnit('month')
        } else {
          if (this.date.length === 0) {
            const h = this.$createElement
            this.$message.error({
              message: h('p', null, [
                h('span', {style: 'color: teal'}, '未选查询时间!  '),
                h('i', {style: 'color: red'}, ' 请选择查询时间段!')
              ])
            })
            return
          }
          this.condition.dateUnit = 'day'
          this.dateUnit = null
          this.energyUnitEnergyData()
        }
      }, excel() {
        if (this.tableData !== null && this.tableData.length !== 0) {
          this.$notify({
            title: '提示',
            message: '正在准备导出,请稍后...',
            position: 'bottom-right',
            showClose: false,
            duration: 800
          })
          console.log('this.tableData')
          console.log(this.tableData)
          this.excelData = formatTitle(this.finallyData, this.dataLabel)
          console.log('this.excelData')
          console.log(this.excelData)
          const result = exportExcel(this.excelData, '能耗量数据', '数据')
          if (result == 0) {
            this.$message({
              type: 'error',
              message: '无待导出数据'
            })
          } else if (result == 1) {
            this.$message({
              type: 'error',
              message: '导出失败'
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: '无待导出数据'
          })
        }
      },
      energyUnitEnergyData() { /* 查询数据 包括能耗量和能耗费用*/
        if (this.condition.energyItemIds === '') return
        this.option = option()
        this.data = []
        this.tableData = []
        this.currentPage = 1
        this.pageTotal = 1
        this.energyMoneySet = []
        this.energyDataSet = []
        this.finallyData = []
        this.energyMoney = []
        this.energyData = []
        this.dataLoading = true
        console.log(this.condition)
        /* this.condition.energyUnitIds = '9eb9741ef1664760a374d75032ebbb8f,605670038d5d4e57b4312c0d45ccbdf9,67d383bc251e4d7e99d4b3afcac19c6e'*/
        energyUnitEnergyData(this.condition).then(response => {/*查询能耗量*/
          if (response.code === 200 && response.infoJson.data !== null && response.infoJson.data.length !== 0) {


            /*能耗量原始信息*/
            /*     console.log('能耗量原始信息')
                 console.log(response.infoJson)*/

            /*根据能耗量和能耗费用分类*/
            const typeArray = formatDataByType(response.infoJson.data)
            /*    console.log('根据能耗量和能耗费用分类')
                console.log(typeArray)*/

            let money = typeArray.money
            /*能耗费用*/
            let energy = typeArray.energy
            /*能耗量*/
            const xAix = response.infoJson.xAix
            const xAixIndex = response.infoJson.xAixIndex
            /* console.log('根据id分类')*/
            const moneyArray = formartDataById(money, this.meters, xAix)
            /*根据id分类*/
            const energyArray = formartDataById(energy, this.meters, xAix)
            /*根据id分类*/


            /*根据时间戳筛选后的信息*/
            for (const i in moneyArray) {
              const d = formartData(moneyArray[i], xAix, xAixIndex)
              this.energyMoneySet.push(d)
              this.energyMoney = this.energyMoney.concat(d)
              /**/
            }
            for (const i in energyArray) {
              const d = formartData(energyArray[i], xAix, xAixIndex)
              this.energyDataSet.push(d)
              this.energyData = this.energyData.concat(d)

              /**/
            }
            console.log('*')
            console.log(this.energyMoneySet)
            console.log(this.energyDataSet)
            /*const energyType = this.meterType + '' === '2' ? '电' : '水'*/
            /*最终数据*/
            this.finallyData = concatAllData(this.energyMoney, this.energyData, this.meters, xAix, this.customerName)
            console.log(this.option)
            if (this.tabPosition === '0') {
              this.drawECharts(this.energyMoneySet)
            }

            else {
              this.drawECharts(this.energyDataSet)
            }
          } else {
            let temp = response.infoJson.xAix

            for (let i in temp) {
              temp[i] = {time: temp[i]}

            }
            let tempSet = []
            console.log(this.meters)
            for (let j in this.meters) {
              temp.name = this.meters[j].name
              tempSet[j] = Object.assign([], temp);
            }

            this.energyMoneySet = tempSet
            this.energyDataSet = tempSet
            if (this.tabPosition === '0') {
              this.drawECharts(this.energyMoneySet)
            }

            else {
              this.drawECharts(this.energyDataSet)
            }
          }


          this.dataLoading = false

        }).catch(error => {
          this.dataLoading = false
          this.$message({
            type: 'warning',
            message: '无该能耗类型数据'
          })
        })

      }, drawECharts(set) {/*获取分组后的数据,显示echarts*/
        console.log(set)

        /* console.log('set')
         console.log(set)*/
        this.option = option()
        this.option.legend.top = '0%'
        this.option.legend.left = '12%'
        this.option.legend.right = '20%'


        this.option.legend.selected = this.selected
        this.option.tooltip.position = (point, params, dom, rect, size) => {/*提示框位置计算*/
          //其中point为当前鼠标的位置，size中有两个属性：viewSize和contentSize，分别为外层div和tooltip提示框的大小
          let x = point[0];//
          let y = point[1];
          let viewWidth = size.viewSize[0];
          let viewHeight = size.viewSize[1];
          let boxWidth = size.contentSize[0];
          let boxHeight = size.contentSize[1];
          let posX = 0;//x坐标位置
          let posY = 0;//y坐标位置

          if (x < boxWidth) {//左边放不开
            posX = 5;
          } else {//左边放的下
            posX = x - boxWidth;
          }

          if (y < boxHeight) {//上边放不开
            posY = 5;
          } else {//上边放得下
            posY = y - boxHeight;
          }

          return [posX, posY];
        }
        if (this.tabPosition === '1') {
          /*this.option.grid = {
            top: '16%',
            left: '5.5%',
            right: '5%',
            bottom: '14%',
            containLabel: false
          }*/
          this.option.yAxis = [
            {
              type: 'value',
              name: '',
              axisLabel: {
                textStyle: {
                  color: '#999',//坐标值得具体的颜色

                },
                formatter: function (value, index) { // 使用函数模板，函数参数分别为刻度数值（类目），刻度的索引
                  if (value >= 1000 && value < 1000000) {
                    value = value / 1000 + "K";
                  } else if (value >= 1000000 && value < 1000000000) {
                    value = value / 1000000 + "M";
                  } else if (value >= 1000000000) {
                    value = value / 1000000000 + "B";
                  } else if (value <= -1000 && value > -1000000) {
                    value = value / 1000 + "K";
                  } else if (value <= -1000000 && value > -1000000000) {
                    value = value / 1000000 + "M";
                  } else if (value <= -1000000000) {
                    value = value / 1000000000 + "B";
                  }
                  return value
                }
              }, axisLine: {
                lineStyle: {
                  type: 'solid',
                  color: '#999'//左边线的颜色
                }
              },
            }
          ]
          this.option.yAxis[0].name = this.dataLabel
        }

        else {
          this.option.yAxis = [
            {

              type: 'value',
              name: '',
              axisLabel: {
                formatter: function (value, index) { // 使用函数模板，函数参数分别为刻度数值（类目），刻度的索引
                  if (value >= 1000 && value < 1000000) {
                    value = value / 1000 + "K";
                  } else if (value >= 1000000 && value < 1000000000) {
                    value = value / 1000000 + "M";
                  } else if (value >= 1000000000) {
                    value = value / 1000000000 + "B";
                  } else if (value <= -1000 && value > -1000000) {
                    value = value / 1000 + "K";
                  } else if (value <= -1000000 && value > -1000000000) {
                    value = value / 1000000 + "M";
                  } else if (value <= -1000000000) {
                    value = value / 1000000000 + "B";
                  }
                  return value
                }
              }, axisLine: {
                lineStyle: {
                  type: 'solid',
                  color: '#999'//左边线的颜色
                }
              }/*,
              minInterval: 0.01*//*最小单位*/
            }
          ]
          this.option.yAxis[0].name = '能耗费用(元)'
        }
        for (const j in set) {
          this.option.legend.data[j] = set[j].name
          this.option.series[j] = {
            name: set[j].name,
            type: 'line',

            yAxisIndex: 0,
            data: [],
            itemStyle: {
              normal: {
                //好，这里就是重头戏了，定义一个list，然后根据所以取得不同的值，这样就实现了，
                color: this.colorList[j]
              }
            },
            smooth: true
            /*,
                  markPoint: {
                    data: [
                      { type: 'max', name: '最大值' },
                      { type: 'min', name: '最小值' }
                    ],
                    symbolSize: [10, 10]
                  }*/
          }
          for (let i = 0; i < set[j].length; i++) {
            if (set[j] === undefined || set[j] === null || set[j].length === 0 || set[j][i].time === undefined || set[j][i].time === null) {
              this.option.xAxis[0].data.push(null)
            }
            /*  else if (this.dateUnit === 'day') {
                if(j == 0) this.option.xAxis[0].data.push(formatToHour(set[j][i].time))
                this.option.legend.data[j] = set[j][i].energyUnitId
                this.option.series[j].name = set[j][i].energyUnitId
              }*/
            if (j == 0) {
              if (this.dateUnit === 'day' || this.dateUnit === 'oneDay') {
                this.option.xAxis[j].data.push(formatToHour(set[j][i].time))
              } else if (this.dateUnit === 'week') {
                /* this.option.xAxis[j].data.push(formatToDay(set[j][i].time) + '号/周' + (i + 1))*/
                this.option.xAxis[j].data.push(formatToDay(set[j][i].time))
              } else if (this.dateUnit === 'month') {
                this.option.xAxis[j].data.push(formatToDay(set[j][i].time))
              } else if (this.dateUnit === 'year') {
                this.option.xAxis[j].data.push(formatToMonth(set[j][i].time))
              } else {
                this.option.xAxis[j].data.push(formatToDay(set[j][i].time))
              }
            }
            /* if(data[i].energyValue > max) max = data[i].energyValue
            max = Math.max(data[i].energyValue, max)*/
            if (set[j][i].energyValue !== undefined)
              this.option.series[j].data.push(set[j][i].energyValue)
            else this.option.series[j].data.push(null)
            /* if (set.length > 31) {
              this.option.dataZoom = {
                realtime: true, // 拖动滚动条时是否动态的更新图表数据
                height: 25, // 滚动条高度
                start: 0, // 滚动条开始位置（共100等份）
                end: 30// 结束位置（共100等份）
              }
            } else this.option.dataZoom = {}*/

            /*
                          this.option.series[1].data.push(data[i].energyValue)*/
          }
        }
        /*  max = max + '';
        let i = max.indexOf('.');
        max = Math.pow(10, max.length - i - 1) * (parseInt(max.charAt(0)) + 1)
         this.option.yAxis[0].max = max;
           this.option.yAxis[0].interval = parseInt(this.option.yAxis[0].max / 10)*/
        /* this.option.xAxis[0].axisLabel.interval = (data.length - 31 <= 0 ? 0 : Math.ceil(data.length / 31 - 1))*/
        console.log('this.option')
        console.log(this.option)
        this.myChart.resize()
        this.myChart.setOption(this.option, true)
        this.tableData = this.searchByPage(this.finallyData)

      }, tableTimeFormat(row, column, cellValue) { // 表格中时间格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          return format(cellValue, 'YYYY-MM-DD HH:mm:ss')
        }
        return '--'
      },
      tableStringFormat(row, column, cellValue) { // 表格中字符串格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          return cellValue
        }
        return '--'
      },
      tableStringToFixed(row, column, cellValue) { // 表格中字符串格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          console.log(cellValue)
          let rs = cellValue.toString().indexOf('.');
          if (rs < 0) {
            cellValue += '.00'
          }
          else {
            cellValue = cellValue.toFixed(2)
          }
          return cellValue;
        }
        return '--'
      },

      click(data, node) { /* 树点击事件 */
        this.selected = []
        console.log(data)
        if (data.type + '' === '1') {
          this.cleanData()
          this.meters = []
          this.expandedCustomerWithMeter(new Array(data)).then(() => {
            this.energyUnitEnergyData()
          })

        } else if (data.type + '' === '2') { /* 仪表 */
          this.cleanData()
          this.condition.energyUnitIds = data.id
          selectMeters(new Array(data.id)).then(response => {
            if (response !== null) {
              this.meters = response
              /*
                            this.meters[0].energyId = data.id*/
              this.energyUnitEnergyData()
            } else {
              this.myChart.resize()
              this.myChart.setOption({}, true)
            }
          }).catch(error => {
            this.$message({
              type: 'error',
              message: '仪表信息查询失败'
            })
            console.log(error)
          })
        }
      },
      changeTime(time) {
        if (time[0].getTime() === time[1].getTime()) {
          this.condition.startDate = time[0]
          time[1].setHours('23')
          time[1].setMinutes('59')
          time[1].setSeconds('59')
          this.condition.endDate = time[1]
          this.condition.dateUnit = 'hour'
          this.dateUnit = 'oneDay'
          this.energyUnitEnergyData()
          return
        }
        this.condition.startDate = time[0]
        this.condition.endDate = time[1]
        this.echarts('day')
      },
      /* 表格间距 */
      cellPadding() {
        return 'padding:0'
      },
      userName(val) {
        this.energyUnitForm.name = this.user.find((item) => {
          return item.id === val
        }).name
      },
      handleSelectionChange(val) { /* 树变化 */
        this.multipleSelection = val
      },
      filterNode(value, data) { /* data.id + ''转字符串,number类型报错*/
        return filterNode(value, data)
        /*if (!value) return true
        const id = (data.code + '').indexOf(value)
        const label = data.label.indexOf(value)
        return (id !== -1 || label !== -1)*/
      },
      selectEnergyUnit() {/*能耗单元树*/
        return new Promise((resolve, reject) => {
          this.option = {}
          this.myChart.resize()
          this.myChart.setOption(this.option, true)
          this.disabled = true
          this.dataLoading = true
          const customerId = this.$store.getters.customerId
          this.condition.customerId = customerId
          this.loading = true
          tree(customerId, null, null, this.meterType, 1).then(response => {
            if (response !== null || response !== undefined) {
              this.tree = response[0].children
              this.disabled = false
              this.loading = false
              resolve(this.tree)
            }
          }).catch(error => {
            this.tree = []
            this.$message({
              type: 'error',
              message: '能耗单元树查询失败'
            })
            this.disabled = false
            this.loading = false
            reject(error)
          })


        })
      },
      expandedCustomerWithMeter(data) {
        return new Promise((resolve, reject) => {
          this.expandedKeys = []
          const keys = expandedCustomerWithMeter(data)

          if (keys === null || keys === undefined) {
            this.dataLoading = false
            this.option = {}
            this.myChart.resize()
            this.myChart.setOption(this.option, true)
            return
          }
          this.customerName = keys[3].name
          this.$refs.tree.setCurrentKey(keys[0].customerId);
          this.expandedKeys.push(keys[0].customerId)
          /*this.condition.energyUnitIds = ''*/
          let energyUnitIds = ''
          /*仪表能耗单元ids*/
          for (const i in keys[2].energyId) {
            energyUnitIds += (keys[2].energyId[i]) + ','
          }

          this.condition.energyUnitIds = energyUnitIds

          /*查询表信息*/
          selectMeters(keys[2].energyId).then(response => {
            if (response !== null) {
              this.meters = response

              resolve(null)
            } else {

            }
          }).catch(error => {
            this.$message({
              type: 'error',
              message: '仪表信息查询失败'
            })
            reject(error)
          })
        })

      },
      success() { /* 成功提示*/
        this.$notify({
          title: ' 成功',
          message: '操作成功',
          type: 'success'
        })
      },
      getNowFormatDate() {
        var date = new Date()
        var seperator1 = '-'
        var year = date.getFullYear()
        var month = date.getMonth() + 1
        var strDate = date.getDate()
        if (month >= 1 && month <= 9) {
          month = '0' + month
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = '0' + strDate
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate
        return currentdate
      },
      changeDateUnit(val) { /* 日周月年查询*/
        this.currentPage = 1
        this.pageTotal = 1
        this.date = []
        if (val === 'day') {
          this.condition.dateUnit = 'hour'
          const startAndEnd = getStartAndEnd('now', 'day')
          this.condition.startDate = startAndEnd.start
          this.condition.endDate = startAndEnd.end
        }
        if (val === 'week') {
          this.condition.dateUnit = 'day'
          const startAndEnd = getStartAndEnd('now', 'week')
          this.condition.startDate = startAndEnd.start
          this.condition.endDate = startAndEnd.end
        }
        if (val === 'month') {
          this.condition.dateUnit = 'day'
          const startAndEnd = getStartAndEnd('now', 'month')
          this.condition.startDate = startAndEnd.start
          this.condition.endDate = startAndEnd.end
        }
        if (val === 'year') {
          this.condition.dateUnit = 'month'
          const startAndEnd = getStartAndEnd('now', 'year')
          this.condition.startDate = startAndEnd.start
          this.condition.endDate = startAndEnd.end
        }
        this.energyUnitEnergyData()
      },
      handleSizeChange: function (size) {
        this.pageSize = size
        this.currentPage = 1
        this.tableData = this.searchByPage(this.finallyData)
      },
      handleCurrentChange: function (currentPage) {
        this.currentPage = currentPage
        this.tableData = this.searchByPage(this.finallyData)
      }

    },
    data() {
      return {
        waterIds: "",
        electricityIds: '',
        energyData: [],
        energyMoney: [],
        energyDataSet: [],
        energyMoneySet: [],
        dataLabel: '能耗量(kWh)',
        currentPage: 1,
        pageSize: 20,
        pageTotal: 1,
        elMainStyle: {
          height: '',
          width: '100%'
        },
        elContent: {
          height: '',
          width: '100%'
        },
        input: '',
        filterText: '',
        tree: [], /* 树*/
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        meters: [],
        customerName: '',
        expandedKeys: [],
        timeData: [],
        enableMeter: [],
        customer: [],
        loading: false, /* 加载*/
        dataLoading: false,
        multipleSelection: '',
        dialogTableVisible: false,
        dialogFormVisible: false,
        condition: {
          dateUnit: 'day',
          startDate: '',
          endDate: '',
          customerId: '',
          energyUnitIds: '', /*9eb9741ef1664760a374d75032ebbb8f,605670038d5d4e57b4312c0d45ccbdf9*/
          energyItemIds: ''/*16396ef1-06a1-4896-a3d6-6c3eb17df360,11d11b4d-d0d6-4953-9273-648b0c800992*/
        },
        dateUnit: 'month',
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const startAndEnd = getStartAndEnd('now', 'week')
              const start = startAndEnd.start
              const end = startAndEnd.end

              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const startAndEnd = getStartAndEnd('now', 'month')
              const start = startAndEnd.start
              const end = startAndEnd.end
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const nowYear = new Date().getFullYear()
              const nowMonth = new Date().getMonth()
              const startAndEnd = getStartAndEnd('now', 'month')
              const monthStartDate = new Date(nowYear, nowMonth - 3, 1)
              const start = new Date(formatDate(monthStartDate) + ' 00:00:00')
              const end = startAndEnd.end
              picker.$emit('pick', [start, end])
              /* console.log()
              let start = formatDate(new Date(new Date()- (3600 * 1000 * 24 * 121))) + ' 00:00:00'
              let end = formatDate(new Date()) + ' 23:59:59'
              picker.$emit('pick', [start, end])*/
            }
          }, {
            text: '最近半年',
            onClick(picker) {
              const nowYear = new Date().getFullYear()
              const nowMonth = new Date().getMonth()
              const startAndEnd = getStartAndEnd('now', 'month')
              const monthStartDate = new Date(nowYear, nowMonth - 6, 1)
              const start = new Date(formatDate(monthStartDate) + ' 00:00:00')
              const end = startAndEnd.end
              picker.$emit('pick', [start, end])
              /* const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
              picker.$emit('pick', [start, end])*/
            }
          }]
        },
        date: [],
        timer: false,
        time: [],
        buttonLoading: false,
        user: [],
        energyUnitForm: {
          id: '',
          name: '',
          enabled: '',
          note: '',
          grade: '',
          order: '',
          approachId: '',
          aName: '',
          parentId: '',
          approachName: '',
          father: {}
        },
        disabled: false,
        customerMeter: {
          id: '',
          meterId: '',
          customerUserId: ''
        },
        meter: [],
        options: [
          {value: '1', label: '区域'},
          {value: '2', label: '楼宇'}
        ],
        value: '区域',
        showType: ''/* 0:添加口径 1:修改口径 2:添加能耗单元 3:添加子能耗单元*/,
        title: '',
        tabPosition: '1',
        meterType: 2,
        tableData: [],
        colorList: ['#009BAC', '#F8AD34', '#F1511B', '#E88678', '#4774BF'],
        finallyData: [],
        excelData: [],
        option: {},
        selected: []
        /* option: {
          noDataLoadingOption: {
            text: '暂无数据',
            effect: 'bubble',
            effectOption: {
              effect: {
                n: 0
              }
            }},

          tooltip: {
            /!* 提示框*!/
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#999'
              }
            }
          },
          toolbox: {
            zlevel: 0, // 所属图形的Canvas分层，zlevel 大的 Canvas 会放在 zlevel 小的 Canvas 的上面
            z: 2, // 所属组件的z分层，z值小的图形会被z值大的图形覆盖
            left: 'right', // 组件离容器左侧的距离,'left', 'center', 'right','20%'
            top: 'top', // 组件离容器上侧的距离,'top', 'middle', 'bottom','20%'
            right: 'auto', // 组件离容器右侧的距离,'20%'
            bottom: 'auto', // 组件离容器下侧的距离,'20%'
            width: 'auto', // 图例宽度
            height: 'auto',
            feature: {
              /!* dataView: {show: true, readOnly: false},*!/
              dataView: { // 数据视图工具，可以展现当前图表所用的数据，编辑后可以动态更新
                show: true, // 是否显示该工具。
                title: '数据视图',
                readOnly: false, // 是否不可编辑（只读）
                lang: ['数据视图', '关闭', '刷新'], // 数据视图上有三个话术，默认是['数据视图', '关闭', '刷新']
                backgroundColor: '#fff', // 数据视图浮层背景色。
                textareaColor: '#fff', // 数据视图浮层文本输入区背景色
                textareaBorderColor: '#333', // 数据视图浮层文本输入区边框颜色
                textColor: '#000', // 文本颜色。
                buttonColor: '#c23531', // 按钮颜色。
                buttonTextColor: '#fff' // 按钮文本颜色。
              },
              magicType: {show: true, type: ['line', 'bar']},
              restore: {show: true},
              saveAsImage: {show: true, title: '保存'},
              dataZoom: { // 数据区域缩放。目前只支持直角坐标系的缩放
                show: true, // 是否显示该工具。
                title: '缩放', // 缩放和还原的标题文本
                xAxisIndex: 0, // 指定哪些 xAxis 被控制。如果缺省则控制所有的x轴。如果设置为 false 则不控制任何x轴。如果设置成 3 则控制 axisIndex 为 3 的x轴。如果设置为 [0, 3] 则控制 axisIndex 为 0 和 3 的x轴
                yAxisIndex: false // 指定哪些 yAxis 被控制。如果缺省则控制所有的y轴。如果设置为 false 则不控制任何y轴。如果设置成 3 则控制 axisIndex 为 3 的y轴。如果设置为 [0, 3] 则控制 axisIndex 为 0 和 3 的y轴
              }

            }
          },
          legend: {
            data: []
          }, grid: {
            top: '11%',
            left: '0%',
            right: '0%',
            bottom: '0%',
            containLabel: true
          },
          xAxis: [
            {
              axisLabel: { // 坐标轴刻度标签的相关设置
                show: true, // 是否显示
                interval: 'auto', // 坐标轴刻度标签的显示间隔，在类目轴中有效。默认会采用标签不重叠的策略间隔显示标签。可以设置成 0 强制显示所有标签。如果设置为 1，表示『隔一个标签显示一个标签』，如果值为 2，表示隔两个标签显示一个标签，以此类推
                inside: false, // 刻度标签是否朝内，默认朝外
                rotate: 35, // 刻度标签旋转的角度，在类目轴的类目标签显示不下的时候可以通过旋转防止标签之间重叠。旋转的角度从 -90 度到 90 度
                margin: 8, // 刻度标签与轴线之间的距离
                formatter: function (value, index) { // 使用函数模板，函数参数分别为刻度数值（类目），刻度的索引
                  return value
                },
                showMinLabel: null, // 是否显示最小 tick 的 label。可取值 true, false, null。默认自动判定（即如果标签重叠，不会显示最小 tick 的 label）
                showMaxLabel: null, // 是否显示最大 tick 的 label。可取值 true, false, null。默认自动判定（即如果标签重叠，不会显示最大 tick 的 label）
                data: []
              },

              splitLine: { // 坐标轴在 grid 区域中的分隔线。
                show: true, // 是否显示分隔线。默认数值轴显示，类目轴不显示。
                interval: 'auto'
              },
              splitArea: { // 坐标轴在 grid 区域中的分隔区域，默认不显示。
                interval: 'auto',
                show: true
              },
              axisTick: { // 坐标轴刻度相关设置
                show: true, // 是否显示坐标轴刻度。
                alignWithLabel: false, // 类目轴中在 boundaryGap 为 true 的时候有效，可以保证刻度线和标签对齐
                interval: 'auto', // 坐标轴刻度的显示间隔，在类目轴中有效。默认会采用标签不重叠的策略间隔显示标签。可以设置成 0 强制显示所有标签。如果设置为 1，表示『隔一个标签显示一个标签』，如果值为 2，表示隔两个标签显示一个标签，以此类推
                inside: false, // 坐标轴刻度是否朝内，默认朝外。
                length: 5 // 坐标轴刻度的长度。

              },
              show: true,
              type: 'category',
              data: [],
              axisPointer: {
                type: 'shadow'
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              name: '能耗量',
              axisLabel: {
                formatter: '{value}'
              }
            }
          ],
          series: [
            {
              name: '',
              type: 'line',
              yAxisIndex: 0,
              data: []
            }
          ]
        }*/
      }
    }
  }
</script>
<!--<style scoped>


    #main {
        width: 100%;
        height: 100%;
    }

    #left {
        float: left;
        width: 250px;
        max-height: 320px;
        height: auto;
        background-color: red;
        /*
                background-color: black;*/
    }

    #content {

        background-color: orange;
        margin-left: 250px;
        height: 300px;
    }

</style>-->
<style scoped rel="stylesheet/scss" lang="scss">


    .energy-data-query-manage-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        font-size: 1rem;
        .recharge-detail-query-head {
            height: 3rem;
            width: 100%;
            display: flex;
            flex-direction: row;
            .recharge-detail-query-head-left {
                padding-top: 1rem;

                font-size: 15px;
                font-weight: 600;

                width: 16%;
                color: black;

                /*background-color: violet;*/
            }
            .recharge-detail-query-head-right {
                font-size: 15px;
                font-weight: 600;
                padding-top: 1rem;
                width: 84%;
                /* background-color: #325dee;*/
            }
        }
        .energy-data-query-content {
            margin-top: 0.5rem;
            height: calc(100% - 6rem);
            display: flex;
            flex-direction: row;
            width: 100%;

            .energy-data-query-left {
                height: 100%;
                width: 16%;
                background-color: white;

                .div-hr {
                    margin-top: calc(0.8rem - 1px);
                    width: 100%;
                    height: 1px;
                    background-color: #d1dbde;
                }
                .left-item {
                    align-items: center;
                    padding-top: 0.5rem;
                    .el-form-item {
                    }
                }
                .tree {

                    margin-top: 0.5rem;
                    padding-bottom: 0.5rem;
                    background-color: white;

                }
                .el-tree {
                    min-width: 100%;
                    display:inline-block !important;
                }

            }
            .energy-data-query-right {
                height: 100%;
                width: calc(84% - 2rem);
                align-items: center;
                margin-left: 2rem;

                .content {
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    height: 100%;
                    .content-table {
                        height: calc(70vh - 16rem);
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        padding-top: 1rem;
                        background-color: white;
                        .energy-data-query-pagination {
                            display: flex;
                            width: 100%;
                            padding-top: 0.5rem;
                            padding-bottom: 0.5rem;
                            height: 2rem;
                            align-items: center;
                            flex-direction: row;
                            background-color: white;
                        }
                    }
                }
            }
        }

    }

    /*#tree.el-tree-node {
        min-width: 100%;
    }*/
    /*.el-main {
        padding: 0;
    }*/

    /*::-webkit-scrollbar { !*滚动条整体样式*!
        width: 6px; !*高宽分别对应横竖滚动条的尺寸*!
        height: 8px;
    }

    ::-webkit-scrollbar-thumb { !*滚动条里面小方块*!
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(210, 210, 210, 210);
        background: rgba(210, 210, 210, 210);
    }

    ::-webkit-scrollbar-track { !*滚动条里面轨道*!
        -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 255);
        border-radius: 0;
        background: rgba(255, 255, 255, 255);
    }
*/
    /*.div-hr {
        height: 1px;
        background-color: #dedede;
        margin-top: 7%;
    }

    .log-condition-box {
        font-size: 14px;
        height: 60px;
        display: flex;
        align-items: center;

    }

    #myChart {
        width: 100%;
        height: 100%;
    }

    .log-search-button {
        margin-top: 10px;
    }*/

</style>
